import { useCallback, memo } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core';
import CustomCheckbox from '../../../customCheckbox';
import UserAvatar from '../../../userAvatar';

const useStyles = makeStyles(({ palette: { primary }, spacing }) => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
  },
  userCheckbox: {
    marginRight: spacing(2),
  },
  userLabel: {
    color: primary.bluish1,
  },
}));

const VirtualUser = ({ user, isSelected, onChange }) => {
  const classes = useStyles();

  const handleChange = useCallback(() => onChange(user), [user, onChange]);

  return (
    <div className={classes.root}>
      <CustomCheckbox
        customRootClass={classes.userCheckbox}
        isChecked={isSelected}
        onChange={handleChange}
        isControlled
      />
      <UserAvatar
        key={user.id}
        labelClass={classes.userLabel}
        variant="subtitle1"
        user={user}
        onClickHandler={handleChange}
        small
        caption
        clickableCaption
      />
    </div>
  );
};

VirtualUser.propTypes = {
  user: PropTypes.object.isRequired,
  isSelected: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default memo(VirtualUser);
